import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { fromEvent } from '#utilities/js/ea/ajax.js'

const handlers = new WeakMap()

const onSubmit = object(listener, {
  once,
  type: submit,
  hooks: array([
    preventDefault
  ]),
  task: async (form, event) => {
    await fromEvent(form, event)
  }
})

const onTapUp = object(listener, {
  type: tapUp,
  passive,
  task: (form, { target: button }) => {
    if (handlers.has(button)) {
      handlers.get(button)({ button, form })
    }
  }
})

export const handle = (button, handler) => {
  handlers.set(button, handler)
}

export default form => {
  onTapUp.listen(form)
}
